/* istanbul ignore file */
export * from './InfiniteProductGrid';
